module.exports = __webpack_public_path__ + "static/Newsletter17-5be01631951b154a88d20593c0d30852.pdf";